export const DataFields = (t) => {
  return [
    {
      name: "",
      fields: [
        {
          id: "fontFaceNameCategories",
          name: t('designmenu_navigation_menu_form_tipography_name'),
          type: "text",
          required: true,
          isImage: true,
          defaultValue: "",
          tooltip: t('designmenu_navigation_menu_form_tipography_name_tooltip'),
          size: "small"
        },
        {
          id: "fontFaceFileCategories",
          name: t('designmenu_navigation_menu_form_tipography_url'),
          type: "text",
          required: true,
          isImage: true,
          defaultValue: "",
          tooltip: t('designmenu_navigation_menu_form_tipography_url_tooltip'),
          size: "small"
        },
        {
          id: "googleFontNameCategories",
          name: t('designmenu_general_features_form_tipography_google'),
          type: "select",
          containerOptions: "googleFonts",
          required: false,
          defaultValue: "",
          size: "small"
        },
        {
          id: "isSameFontFaceBody",
          name: t('designmenu_navigation_menu_form_same_tipography'),
          type: "switch",
          required: true,
          defaultValue: false,
          tooltip: t('designmenu_navigation_menu_form_same_tipography_tooltip'),
          size: "small"
        },
        {
          id: "textColorCategories",
          name: t('designmenu_navigation_menu_form_tipography_color'),
          type: "color",
          required: true,
          defaultValue: "#000000",
          tooltip: t('designmenu_navigation_menu_form_tipography_color_tooltip'),
          size: "small"
        },
        {
          id: "fontSizePCTextCategories",
          name: t('designmenu_navigation_menu_form_text_size_pc'),
          type: "number",
          required: true,
          defaultValue: 38,
          tooltip: t('designmenu_navigation_menu_form_text_size_pc_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "fontSizeMovilTextCategories",
          name: t('designmenu_navigation_menu_form_text_size_mobil'),
          type: "number",
          required: true,
          defaultValue: 24,
          tooltip: t('designmenu_navigation_menu_form_text_size_mobil_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "backgroungImageCategories",
          name: t('designmenu_navigation_menu_form_background_image'),
          type: "image",
          required: true,
          isImage: true,
          defaultValue: "",
          tooltip: t('designmenu_navigation_menu_form_background_image_tooltip'),
          size: "small"
        },
        {
          id: "activeIndicatorColorCategories",
          name: t('designmenu_navigation_menu_form_active_category_color'),
          type: "color",
          required: true,
          defaultValue: "#000000",
          tooltip: t('designmenu_navigation_menu_form_active_category_color_tooltip'),
          size: "small"
        },
        {
          id: "colorArrowsCategories",
          name: t('designmenu_navigation_menu_form_arrows_color'),
          type: "color",
          required: true,
          defaultValue: "#000000",
          tooltip: t('designmenu_navigation_menu_form_arrows_color_tooltip'),
          size: "small"
        },
        {
          id: "colorDotsCategories",
          name: t('designmenu_navigation_menu_form_dots_color'),
          type: "color",
          required: true,
          defaultValue: "#000000",
          tooltip: t('designmenu_navigation_menu_form_dots_color_tooltip'),
          size: "small"
        }
      ]
    }
  ]
}